export * from './_iconNames'
export * from './events'
export * from './footer'
export * from './card-photo-video'
export * from './header'
export * from './product'
export * from './basket'
export * from './_customSdk'
export * from './page'
export * from './locale'
export * from './routes'
export * from './banner-news-item'
export * from './newsletter'
export * from './search'
export * from './wishlist'
export * from './tencentRecaptcha'
export * from './order'
export * from './minicart'
export * from './login'
export * from './cloudinary'
export * from './category'
export * from './shop-image-data'
export * from './dynamic-yield'
export * from './boutique'
export * from './forms'
export * from './size-guide'

import {TencentCaptchaResponse, TencentCaptcha} from './tencentRecaptcha'
declare global {
    interface Window {
        dataLayer?: Array<{[key: string]: unknown}>
        TencentCaptcha?: new (appId: string, callback: (res: TencentCaptchaResponse) => void) => TencentCaptcha
    }
}
